import { FiltersDrawerHeader } from './FiltersDrawerHeader';

export default FiltersDrawerHeader;
